import { Grid, Link, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../redux";
import { selectText } from "../LanguageSelect/LanguageSelectSlice";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useEffect, useState } from "react";
import { resetAppState } from "../../AppSlice";
import { resetInfoPageState } from "../InfoPage/InfoPageSlice";
import { resetContactInfoState } from "./ContactInfoSlice";
import { resetRegistrationPageState } from "../RegistrationPage/RegistrationPageSlice";
import { resetImageCaptureState } from "../ImageCapture/ImageCaptureSlice";
import { SP_URL } from "../../constants";

export function PaneemConfirmPage() {
  const text = useAppSelector(selectText);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);

  const dispatch = useAppDispatch();

  useEffect(() => {
    setTimeoutId(
      setTimeout(() => {
        dispatch(resetAppState());
        dispatch(resetInfoPageState());
        dispatch(resetContactInfoState());
        dispatch(resetRegistrationPageState());
        dispatch(resetImageCaptureState());
      }, 60000)
    );

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  return (
    <Grid container spacing={2} alignItems={"center"} justifyContent={"center"}>
      <Grid item xs={10} xl={10} sx={{}}>
        <Typography component="h1" variant="h3" textAlign={"center"}>
          {text.paneemConfirm.par1}
        </Typography>
      </Grid>
      <Grid item xs={10} xl={10} sx={{}}>
        <Typography component="h1" variant="h3" textAlign={"center"}>
          {text.paneemConfirm.par2}
        </Typography>
      </Grid>
      <Grid item xs={10} xl={10} sx={{}}>
        <Typography component="h1" variant="h3" textAlign={"center"}>
          {text.paneemConfirm.par3}
        </Typography>
      </Grid>
      <Grid item xs={10} xl={10} sx={{ textAlign: "center" }}>
        <CheckCircleIcon fontSize="large" />
      </Grid>
      <Grid item xs={10} xl={10} sx={{}}>
        <Typography component="h1" variant="h3" textAlign={"center"}>
          {text.paneemConfirm.par4}
        </Typography>
        <br></br>
        <Typography component="h1" variant="h3" textAlign={"center"}>
          <Link target="_blank" href={SP_URL}>
            {text.paneemConfirm.par5}
          </Link>
        </Typography>
      </Grid>
    </Grid>
  );
}
